import api from '@/api'

export default {
  getCompanyList(): Promise<Array<orgmap.ResponseCompany>> {
    return api.get<Array<orgmap.ResponseCompany>>({ url: '/api/hk/ipt/company/list' })
  },


  call(data: orgmap.RequestCallIPT) {
    return api.post({
      url: '/api/hk/ipt/call',
      data: data,
    })
  },

}
